import React from 'react';
import { Link } from "react-router-dom";
import moment from "moment";
import { DATE_FORMAT } from '../../../../constants';
import './Table.css'

export const TABLE_COLUMNS = [
    {
        Header: 'Case Name',
        id: "counterpartyName",
        accessor: d => <Link id={d.caseId} to={`/case/view/${d.caseId}`} title={d.caseId} className={d.status === 'REOPENED' ? 'text-danger' : ''}>{d.counterpartyName}</Link>
    },
    {
        Header: 'Corporate Name',
        id: "corporateName",
        accessor: d => <div title={d.corporateName}>{d.corporateName}</div>
    },
    {
        Header: "Product Name",
        id: "productName",
        accessor: d => <div className="productName-cell" title={d.productName}>{d.productName}</div>,
      },
    {
        Header: 'Counterparty Type',
        id: "counterpartyType",
        accessor: d => <div title={d.counterpartyType}>{d.counterpartyType}</div>
    },
    {
        Header: "Identifiers",
        id: "identifiers",
        accessor: p => (
          <div title={p.gstNo ? p.gstNo : p.cinNumber ? p.cinNumber : p.panNo}>
            {p.panNo ? "PAN : " + p.panNo : null}
            {p.gstNo && p.panNo ? <br /> : null }
            {p.gstNo ? "GST : " + p.gstNo : null}
            {p.cinNumber && (p.panNo || p.gstNo)? <br /> : null}
            {p.cinNumber ? "CIN : " + p.cinNumber : null}
          </div>
        ),
        width: 250
    },
    {
        Header: "Created On",
        id: "createdAt",
        accessor: p => <div title={moment(p.createdAt).format(DATE_FORMAT)}>{moment(p.createdAt).format(DATE_FORMAT)}</div>,
        width: 120
    },
    {
        Header: "Updated On",
        id: "updatedAt",
        accessor: p => <div title={moment(p.updatedAt).format(DATE_FORMAT)}>{moment(p.updatedAt).format(DATE_FORMAT)}</div>,
        width: 120
    }
]
